import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { FaSpinner } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import localforage from "localforage";
// import { MdOutlineAddToPhotos } from "react-icons/md";
import { MdOutlineNoteAdd } from "react-icons/md";
import { useSecurityMaster } from "../../context/SecurityMasterContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";

import { usePcr } from "../../context/PcrContext";
import { useOption } from "../../context/OptionContext";

import { PiChartLineDownBold } from "react-icons/pi";

import "./StockDetail.css";

import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  Legend,
  ComposedChart,
} from "recharts";
// import {  } from "recharts";

import StockCard from "../StockCard/StockCard";
import AnalysisCard from "../AnalysisCard/AnalysisCard";
import { BsBuilding } from "react-icons/bs"; // Company
import {
  FaRupeeSign,
  FaArrowUp,
  FaArrowDown,
  FaChartLine,
  FaChartBar,
  FaProjectDiagram,
} from "react-icons/fa";
import { MdBarChart, MdShowChart } from "react-icons/md";
// import { useStockDetail } from "../../context/StockDetailContext";

function StockDetails() {
  const { ric, id, stock_name } = useParams(); // e.g. "KTKM.NS"
  const { pcrStore, loadData, refresh } = usePcr();

  console.log("ric:-", ric);
  // const BASE_URL = "http://localhost:8000";
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [historical, setHistorical] = useState([]);
  const [stock, setStock] = useState(null);
  const [closingPrices, setClosingPrices] = useState([]); // ✅ add this
  const [detail, setDetail] = useState(null);
  const [activeStocks, setActiveStocks] = useState([]);
  const [dateData, setDateData] = useState([]);
  const [stockDataId, setStockDataId] = useState([]);
  const [intraday, setIntraday] = useState(null);
  const [timeFrame, setTimeFrame] = useState("day");
  const [error, setError] = useState(null);
  const [stockDet, setStockDet] = useState(null);
  const [lastFetched, setLastFetched] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [targetPrice, setTargetPrice] = useState(null);
  const [peerPEData, setPeerPEData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");
  const [securityId, setSecurityId] = useState();
  const { fetchBySymbol, pcr } = useOption();
  const {
    indicatorData,
    fetchIndicators,
    getPrevClose,
    previousClose,
    quoteData,
    getMarketQuote,
  } = useMarketIndicators();
  //time
  // const { store, fetchStockData } = useStockDetail();

  localforage.config({
    name: "StockAppCache",
    storeName: "stock_data",
    description: "Stores cached stock data efficiently",
  });

  const [indicators, setIndicators] = useState({
    rsi: [],
    ema: [],
    sma: [],
    macd: [],
  }); // ✅ add this
  const [loading, setLoading] = useState(false);

  // remove ".NS" postfix
  console.log("Id is ", id);
  // const stockName = ric.replace(".NS", "");
  const [stockId, setStockId] = useState(null);
  // console.log("StockName", stockName);
  const navigate = useNavigate();

  // useEffect(() => {

  //   const fetchDetails = async () => {
  //     try {
  //       setLoading(true);
  //       console.log("ID being sent:", id);

  //       const params = {};
  //       if (id) params.id = id;

  //       // const response = await axios.get(
  //       //   "http://localhost:8000/api/stockdata",
  //       //   {
  //       //     params,
  //       //   }
  //       // );
  //       const response = await axios.get(`${BASE_URL}/api/stockdata`, {
  //         params,
  //       });
  //       setDetail(response.data);
  //     } catch (err) {
  //       console.log("Error is:-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   const fetchActive = async () => {
  //     try {
  //       setLoading(true);
  //       // const response = await axios.get(
  //       //   "http://localhost:8000/api/most-active"
  //       // );
  //       const response = await axios.get(`${BASE_URL}/api/most-active`);
  //       console.log("Active data", response.data);
  //       setActiveStocks(response.data);
  //     } catch (err) {
  //       console.log("Error is :-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchActive();
  //   // fetchLiveStock();
  //   // fetchHistorical();
  //   fetchDetails();
  //   // fetchStockData();
  // }, []);
  // console.log("Live Stock", stock);
  // console.log("Details", detail);
  // const companyName = detail?.companyName;
  // console.log("COmpanyName", companyName);
  // const stockNseCode = detail?.companyProfile?.exchangeCodeNse;
  // console.log("nsecode", stockNseCode);
  // console.log("STOCK COMPAY", detail?.companyProfile?.peerCompanyList);
  // console.log("Code", stockDataId);
  // console.log("Active Stocks", activeStocks);
  // console.log("StockId", stockId);
  // // const stId = stockDataId?.companyProfile?.peerCompanyList?.[0]?.tickerId;
  // const newStockId = stockDataId?.companyProfile?.peerCompanyList;

  // const stockIdObject = detail?.companyProfile?.peerCompanyList?.find(
  //   (stock) => stock.companyName?.toLowerCase() === companyName?.toLowerCase()
  // );
  // const stockIdNse = stockIdObject?.tickerId;
  // console.log("stockIdNse", stockIdNse);
  // console.log("stockIdObjec", stockIdObject);
  // console.log("newStckid", newStockId);

  // useEffect(() => {
  //   const fetchHistorical = async () => {
  //     if (!stockNseCode) {
  //       console.warn("No NSE Code provided");
  //       return;
  //     }

  //     try {
  //       setLoading(true);

  //       // const response = await axios.get(
  //       //   "http://localhost:8000/api/historical",
  //       //   {
  //       //     params: {
  //       //       stock_name: stockNseCode,
  //       //       period: "6m",
  //       //       filter: "price",
  //       //     },
  //       //   }
  //       // );
  //       const response = await axios.get(`${BASE_URL}/api/historical`, {
  //         params: {
  //           stock_name: stockNseCode,
  //           period: "6m",
  //           filter: "price",
  //         },
  //       });

  //       console.log("Full API Response:", response.data);

  //       // Safely extract data
  //       const histData = response.data?.historicalData?.data || [];
  //       const closing = response.data?.closingPrices || [];
  //       const indi = response.data?.indicators || {};
  //       const dates = response.data?.historicaldata || [];

  //       setHistorical(histData);
  //       setClosingPrices(closing);
  //       setIndicators(indi);
  //       setDateData(dates);
  //     } catch (err) {
  //       console.error("Error fetching historical:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   const fetchLiveStock = async () => {
  //     try {
  //       setLoading(true);

  //       // const response = await axios.post("http://localhost:8000/api/nsedata", {
  //       //   stock_symbols: [stockNseCode],
  //       // });
  //       const response = await axios.post(`${BASE_URL}/api/nsedata`, {
  //         stock_symbols: [stockNseCode],
  //       });
  //       setStock(response.data[stockNseCode]);
  //     } catch (err) {
  //       console.log("Error is:-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   const fetchStockDetails = async () => {
  //     try {
  //       setLoading(true);
  //       // const response = await axios.get("http://localhost:8000/api/stock", {
  //       //   params: { stock_name: stockNseCode },
  //       // });
  //       const response = await axios.get(`${BASE_URL}/api/stock`, {
  //         params: { stock_name: stockNseCode },
  //       });
  //       setStockDet(response.data);
  //     } catch (err) {
  //       console.log("Error is:-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchHistorical();
  //   fetchLiveStock();
  //   fetchStockDetails();
  // }, [stockNseCode]);
  // console.log("Historical", historical);
  // console.log("Live stock", stock);
  // const low = stock?.low;
  // const high = stock?.high;
  // const close = stock?.close;
  // console.log("High", high);
  // console.log("low", low);
  // console.log("close", close);
  // const pivot = (low + high / close) / 3;
  // console.log("Pivot", pivot);
  // const support1 = 2 * pivot - high;
  // const resistance1 = 2 * pivot - low;
  // console.log("Support is", support1);
  // console.log("resistance is", resistance1);
  // console.log("Stock details for pe and fc", stockDet);

  // useEffect(() => {
  //   const fetchIntraday = async () => {
  //     if (!id) return; // wait until we have tickerId

  //     try {
  //       setLoading(true);
  //       // const response = await axios.post(
  //       //   "http://localhost:8000/api/intraday",
  //       //   {
  //       //     stock_id: id, // ✅ pass tickerId
  //       //   }
  //       // );
  //       const response = await axios.post(`${BASE_URL}/api/intraday`, {
  //         stock_id: id, // ✅ pass tickerId
  //       });
  //       setIntraday(response.data);
  //       console.log("Intraday Data:", response.data);
  //     } catch (err) {
  //       console.error("Error fetching intraday:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchIntraday();
  // }, [id]);
  // const fetchAllStockData = async (forceRefresh = false) => {
  //   const cacheKey = `stock_${id}_cache`;

  //   try {
  //     setLoading(true);

  //     // ✅ Try cache first (unless manually refreshed)
  //     const cached = JSON.parse(localStorage.getItem(cacheKey));
  //     if (cached && !forceRefresh) {
  //       console.log(`✅ Using cached data for stock ID: ${id}`);
  //       setDetail(cached.detail);
  //       setActiveStocks(cached.activeStocks);
  //       setStock(cached.stock);
  //       setStockDet(cached.stockDet);
  //       setHistorical(cached.historical);
  //       setIndicators(cached.indicators);
  //       setDateData(cached.dateData);
  //       setIntraday(cached.intraday);
  //       setLastFetched(cached.timestamp);
  //       setLoading(false);
  //       return;
  //     }

  //     console.log(`🆕 Fetching new data for stock ID: ${id}`);

  //     // ✅ 1️⃣ Fetch Details
  //     console.log("Fetching Stock Details...");
  //     const detailRes = await axios.get(`${BASE_URL}/api/stockdata`, {
  //       params: { id },
  //     });
  //     setDetail(detailRes.data);
  //     console.log("Details", detailRes.data);

  //     // ✅ 2️⃣ Fetch Active Stocks
  //     console.log("Fetching Most Active Stocks...");
  //     // const activeRes = await axios.get(`${BASE_URL}/api/most-active`);
  //     // setActiveStocks(activeRes.data);
  //     // console.log("Active data", activeRes.data);

  //     // const stockNseCode = detailRes.data?.companyProfile?.exchangeCodeNse;
  //     const stockNseCode = (
  //       detailRes.data?.companyProfile?.exchangeCodeNse || ""
  //     ).includes("-")
  //       ? detailRes.data?.companyProfile?.exchangeCodeNse.replace(/-/g, "")
  //       : detailRes.data?.companyProfile?.exchangeCodeNse;

  //     console.log("nsecode", stockNseCode);

  //     if (!stockNseCode) {
  //       console.warn("⚠️ No NSE code found, skipping dependent calls");
  //       setLoading(false);
  //       return;
  //     }

  //     // ✅ 3️⃣ Fetch Historical Data
  //     console.log("Fetching Historical Data...");
  //     const histRes = await axios.get(`${BASE_URL}/api/historical`, {
  //       params: { stock_name: stockNseCode, period: "6m", filter: "price" },
  //     });
  //     const histData = histRes.data?.historicalData?.data || [];
  //     const indi = histRes.data?.indicators || {};
  //     const dates = histRes.data?.historicaldata || [];
  //     setHistorical(histData);
  //     setIndicators(indi);
  //     setDateData(dates);
  //     console.log("Historical", histData);

  //     // ✅ 4️⃣ Fetch Live Stock
  //     console.log("Fetching Live NSE Stock...");
  //     const liveRes = await axios.post(`${BASE_URL}/api/nsedata`, {
  //       stock_symbols: [stockNseCode],
  //     });
  //     const liveStock = liveRes.data[stockNseCode];
  //     setStock(liveStock);
  //     console.log("Live Stock", liveStock);

  //     // ✅ 5️⃣ Fetch Stock Details for PE Ratio
  //     console.log("Fetching Stock Detail Stats...");
  //     const stockRes = await axios.get(`${BASE_URL}/api/stock`, {
  //       params: { stock_name: stockNseCode },
  //     });
  //     setStockDet(stockRes.data);
  //     console.log("Stock details for pe and fc", stockRes.data);

  //     // ✅ 6️⃣ Fetch Intraday Data
  //     console.log("Fetching Intraday Data...");
  //     const intraRes = await axios.post(`${BASE_URL}/api/intraday`, {
  //       stock_id: id,
  //     });
  //     setIntraday(intraRes.data);
  //     console.log("Intraday Data", intraRes.data);

  //     // ✅ Cache all fetched data
  //     const cachePayload = {
  //       detail: detailRes.data,
  //       // activeStocks: activeRes.data,
  //       stock: liveStock,
  //       stockDet: stockRes.data,
  //       historical: histData,
  //       intraday: intraRes.data,
  //       indicators: indi,
  //       dateData: dates,
  //       timestamp: Date.now(),
  //     };
  //     localStorage.setItem(cacheKey, JSON.stringify(cachePayload));
  //     setLastFetched(Date.now());

  //     console.log(`💾 Cached data for stock ID: ${id}`);
  //   } catch (err) {
  //     console.error("❌ Error fetching stock data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const fetchAllStockData = async (forceRefresh = false) => {
  //   const cacheKey = `stock_${id}_cache`;
  //   console.log("🚀 Starting fetchAllStockData for ID:", id);

  //   try {
  //     if (!id) {
  //       console.warn("⚠️ No ID provided, skipping fetch");
  //       return;
  //     }

  //     setLoading(true);

  //     // ✅ Safe cache parsing
  //     let cached = null;
  //     try {
  //       cached = JSON.parse(localStorage.getItem(cacheKey));
  //     } catch (e) {
  //       console.warn("⚠️ Corrupt cache, clearing...");
  //       localStorage.removeItem(cacheKey);
  //     }

  //     console.log("📦 Cached data:", cached);

  //     // ✅ Use cache if available
  //     if (cached && !forceRefresh) {
  //       console.log(`✅ Using cached data for stock ID: ${id}`);
  //       setDetail(cached.detail);
  //       setStock(cached.stock);
  //       setStockDet(cached.stockDet);
  //       setHistorical(cached.historical);
  //       setIndicators(cached.indicators);
  //       setDateData(cached.dateData);
  //       setIntraday(cached.intraday);
  //       setLastFetched(cached.timestamp);
  //       setLoading(false);
  //       return;
  //     }

  //     console.log("🆕 Fetching new data for stock ID:", id);

  //     // ✅ Step 1: Fetch Stock Details
  //     console.log("1️⃣ Fetching Stock Details...");
  //     let detailRes;
  //     try {
  //       detailRes = await axios.get(`${BASE_URL}/api/stockdata`, {
  //         params: { id },
  //       });
  //     } catch (err) {
  //       console.error("❌ Failed fetching /api/stockdata:", err.message);
  //       setLoading(false);
  //       return;
  //     }

  //     console.log("✅ Stock Details:", detailRes.data);
  //     setDetail(detailRes.data);

  //     // ✅ Step 2: Clean NSE code
  //     const rawCode = detailRes.data?.companyProfile?.exchangeCodeNse || "";
  //     const stockNseCode = rawCode.includes("-")
  //       ? rawCode.replace(/-/g, "")
  //       : rawCode;

  //     console.log("🔹 Cleaned NSE Code:", stockNseCode);

  //     if (!stockNseCode) {
  //       console.warn("⚠️ No NSE code found, skipping dependent calls");
  //       setLoading(false);
  //       return;
  //     }

  //     // ✅ Step 3: Fetch Historical Data
  //     console.log("2️⃣ Fetching Historical Data...");
  //     let histRes;
  //     try {
  //       histRes = await axios.get(`${BASE_URL}/api/historical`, {
  //         params: { stock_name: stockNseCode, period: "6m", filter: "price" },
  //       });
  //     } catch (err) {
  //       console.error("❌ Failed fetching /api/historical:", err.message);
  //       histRes = { data: {} };
  //     }

  //     const histData = histRes.data?.historicalData?.data || [];
  //     const indi = histRes.data?.indicators || {};
  //     const dates = histRes.data?.historicaldata || [];
  //     console.log("✅ Historical data fetched:", histData.length);
  //     setHistorical(histData);
  //     setIndicators(indi);
  //     setDateData(dates);

  //     // ✅ Step 4: Fetch Live NSE Stock
  //     console.log("3️⃣ Fetching Live NSE Stock...");
  //     let liveRes;
  //     try {
  //       liveRes = await axios.post(`${BASE_URL}/api/nsedata`, {
  //         stock_symbols: [stockNseCode],
  //       });
  //     } catch (err) {
  //       console.error("❌ Failed fetching /api/nsedata:", err.message);
  //       liveRes = { data: {} };
  //     }

  //     const liveStock = liveRes.data[stockNseCode];
  //     console.log("✅ Live Stock:", liveStock);
  //     setStock(liveStock);

  //     // ✅ Step 5: Fetch PE & FC details
  //     console.log("4️⃣ Fetching Stock PE/FC Data...");
  //     let stockRes;
  //     try {
  //       stockRes = await axios.get(`${BASE_URL}/api/stock`, {
  //         params: { stock_name: stockNseCode },
  //       });
  //     } catch (err) {
  //       console.error("❌ Failed fetching /api/stock:", err.message);
  //       stockRes = { data: {} };
  //     }

  //     console.log("✅ Stock Details:", stockRes.data);
  //     setStockDet(stockRes.data);

  //     // ✅ Step 6: Fetch Intraday
  //     console.log("5️⃣ Fetching Intraday Data...");
  //     let intraRes;
  //     try {
  //       intraRes = await axios.post(`${BASE_URL}/api/intraday`, {
  //         stock_id: id,
  //       });
  //     } catch (err) {
  //       console.error("❌ Failed fetching /api/intraday:", err.message);
  //       intraRes = { data: {} };
  //     }

  //     console.log("✅ Intraday Data:", intraRes.data);
  //     setIntraday(intraRes.data);

  //     // ✅ Step 7: Cache Everything
  //     const cachePayload = {
  //       detail: detailRes.data,
  //       stock: liveStock,
  //       stockDet: stockRes.data,
  //       historical: histData,
  //       intraday: intraRes.data,
  //       indicators: indi,
  //       dateData: dates,
  //       timestamp: Date.now(),
  //     };

  //     localStorage.setItem(cacheKey, JSON.stringify(cachePayload));
  //     setLastFetched(Date.now());
  //     console.log(`💾 Cached data for stock ID: ${id}`);
  //   } catch (err) {
  //     console.error("🔥 Unexpected Error in fetchAllStockData:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const { getSecurityIds } = useSecurityMaster();

  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };

  const fetchAllStockData = async (forceRefresh = false) => {
    const cacheKey = `stock_${id}_cache`;
    console.log("🚀 Starting fetchAllStockData for ID:", id);

    try {
      if (!id) {
        console.warn("⚠️ No ID provided, skipping fetch");
        setError("No valid stock ID provided.");
        return;
      }

      setLoading(true);
      setError(null);

      // ✅ 1️⃣ Try reading from cache
      let cached = null;
      try {
        cached = await localforage.getItem(cacheKey);
      } catch (err) {
        console.error("❌ Error reading cache:", err);
      }

      console.log("📦 Cached data:", cached);

      // ✅ 2️⃣ Use cached data if available
      if (cached && !forceRefresh) {
        console.log(`✅ Using cached data for stock ID: ${id}`);
        setDetail(cached.detail);
        setStock(cached.stock);
        setStockDet(cached.stockDet);
        setHistorical(cached.historical);
        setIndicators(cached.indicators);
        setDateData(cached.dateData);
        setIntraday(cached.intraday);
        setLastFetched(cached.timestamp);
        setTargetPrice(cached.targetPrice);
        setLoading(false);
        return;
      }

      console.log("🆕 Fetching new data for stock ID:", id);

      // ✅ 3️⃣ Fetch Stock Details
      console.log("1️⃣ Fetching Stock Details...");
      const detailRes = await axios.get(`${BASE_URL}/api/stockdata`, {
        params: { id },
      });
      const detailData = detailRes;
      setDetail(detailRes.data);
      console.log("✅ Stock Details:", detailRes.data);
      console.log("Detail data", detailData);

      const company = detailRes.data.companyName;
      console.log("COmpany", company);

      try {
        console.log("Entering try block");
        const peers = detailData.data?.companyProfile?.peerCompanyList || [];
        console.log("Peers:", peers);

        if (peers.length === 0) {
          console.log("ℹ️ No peer companies found, skipping peer fetch");
        } else {
          console.log(`🔍 Fetching full data for ${peers.length} peers...`);

          const peerRequests = peers.map(async (peer) => {
            const peerName = peer.companyName?.trim();
            if (!peerName) return { name: "Unknown", data: null };

            try {
              const res = await axios.get(`${BASE_URL}/api/stock`, {
                params: { stock_name: peerName },
              });

              console.log(`📊 Response for ${peerName}:`, res.data);

              // Attach the full API response with the peer name
              return { name: peerName, peRatio: res.data.stats.peRatio };
            } catch (err) {
              console.error(
                `❌ Failed to fetch data for ${peerName}:`,
                err.message,
              );
              return { name: peerName, peRatio: null };
            }
          });

          // Wait for all requests
          const peerResults = await Promise.all(peerRequests);
          setPeerPEData(peerResults);
          console.log("✅ Peer Full Data:", peerResults);
        }
      } catch (err) {
        console.error("⚠️ Error fetching peer data:", err);
      }

      // ✅ Clean NSE code
      const stockNseCode = detailRes.data?.companyProfile?.exchangeCodeNse;
      // console.log("Rawcode", rawCode);
      // const stockNseCode = rawCode.includes("-")
      //   ? rawCode.replace(/-/g, "")
      //   : rawCode;

      console.log("🔹 Cleaned NSE Code:", stockNseCode);

      if (!stockNseCode) {
        console.warn("⚠️ No NSE code found, skipping dependent calls");
        setLoading(false);
        return;
      }

      // ✅ 4️⃣ Fetch Historical Data
      console.log("2️⃣ Fetching Historical Data...");
      const stockParam = stockNseCode?.includes("-") ? company : stockNseCode;

      console.log("📤 Fetching historical data for:", stockParam);

      const histRes = await axios.get(`${BASE_URL}/api/historical`, {
        params: { stock_name: stockParam, period: "6m", filter: "price" },
      });

      const histData = histRes.data?.historicalData?.data || [];
      const indi = histRes.data?.indicators || {};
      const dates = histRes.data?.historicaldata || [];
      setHistorical(histData);
      setIndicators(indi);
      setDateData(dates);
      console.log("✅ Historical data fetched:", histData.length);

      // ✅ 5️⃣ Fetch Live NSE Stock
      console.log("3️⃣ Fetching Live NSE Stock...");
      const liveRes = await axios.post(`${BASE_URL}/api/nsedata`, {
        stock_symbols: [stockNseCode],
      });
      const liveStock = liveRes.data[stockNseCode];
      setStock(liveStock);
      console.log("✅ Live Stock:", liveStock);

      // ✅ 6️⃣ Fetch PE & FC details
      console.log("4️⃣ Fetching Stock Detail Stats...");
      const stockRes = await axios.get(`${BASE_URL}/api/stock`, {
        params: { stock_name: stockNseCode },
      });
      setStockDet(stockRes.data);
      console.log("✅ Stock details for PE/FC:", stockRes.data);

      // ✅ 7️⃣ Fetch Intraday Data
      console.log("5️⃣ Fetching Intraday Data...");
      const intraRes = await axios.post(`${BASE_URL}/api/intraday`, {
        stock_id: id,
      });
      setIntraday(intraRes.data);
      console.log("✅ Intraday Data:", intraRes.data);

      //fetch target price
      console.log("Nsecode", stockNseCode);
      const targetRes = await axios.get(`${BASE_URL}/api/stocktarget`, {
        params: { symbol: stockNseCode },
      });
      setTargetPrice(targetRes.data);
      console.log("Target Price", targetRes.data);

      // ✅ 8️⃣ Cache everything in localforage
      const cachePayload = {
        detail: detailRes.data,
        stock: liveStock,
        stockDet: stockRes.data,
        historical: histData,
        intraday: intraRes.data,
        indicators: indi,
        dateData: dates,
        targetPrice: targetRes.data,
        timestamp: Date.now(),
      };

      try {
        await localforage.setItem(cacheKey, cachePayload);
        console.log(`💾 Cached data for stock ID: ${id} (using IndexedDB)`);
      } catch (err) {
        console.error("❌ Failed to write cache:", err);
      }

      setLastFetched(Date.now());
    } catch (err) {
      console.error("🔥 Unexpected Error in fetchAllStockData:", err);
      setError("Api Failed!");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Initial load (runs only once per stock)

  console.log("Details", detail);
  console.log("Active Stocks", activeStocks);
  console.log("Stock", stock);
  console.log("Indicators", indicators);
  console.log("Intraday", intraday);
  console.log("TargetPrice", targetPrice);
  // const data = store[id];

  // console.log("Context data is", data);

  // ✅ Manual Refresh button
  const handleRefresh = async () => {
    setIsRefreshing(true);
    await fetchAllStockData(true);
    setIsRefreshing(false);
  };

  console.log("Intraday", intraday);
  const intradayIndicators = intraday?.indicators;
  console.log("IntradayIndi", intradayIndicators);

  console.log("Historical", historical);
  console.log("Target Price", targetPrice);
  console.log("Date", dateData);
  const companyName = detail?.companyName;
  console.log("Company Name", companyName);
  const companyCode = detail?.companyProfile?.exchangeCodeNse;
  console.log("CompanyCode", companyCode);
  const peerCompany = detail?.companyProfile?.peerCompanyList.filter(
    (stock) => stock.companyName.toLowerCase() !== companyName.toLowerCase(),
  );
  console.log("Peer Company", peerCompany);
  console.log("Peer company PE Ratio", peerPEData);
  const mergedPeers = peerCompany?.map((peer) => {
    // find the matching peer in peerPEData
    const match = peerPEData?.find(
      (p) =>
        p.name?.trim().toLowerCase() ===
        peer?.companyName?.trim().toLowerCase(),
    );

    // attach peRatio if found, else keep as "N/A"
    return {
      ...peer,
      peRatio: match ? match.peRatio : "N/A",
    };
  });
  console.log("Matched", mergedPeers);

  console.log("🔗 Merged Peer Data with Attached PE Ratios:", mergedPeers);

  // const matchStock = activeStocks.filter((item) => item.ticker === ric);
  // console.log("match", matchStock);
  // const matchStockData = matchStock[0];
  const peRatio = stockDet?.stats?.peRatio;
  const faceValue = stockDet?.stats?.faceValue;
  const target_price = targetPrice?.priceTarget?.Mean;
  console.log("Final target price", target_price);
  const projectChange = (
    ((target_price - stock?.ltp) / stock?.ltp) *
    100
  ).toFixed(2);
  console.log("ProjectedChange", projectChange);
  console.log("Pe", peRatio);
  console.log("fv", faceValue);
  const histoDay = indicators;
  const macdChartData =
    Array.isArray(indicators.macd) &&
    indicators.macd.map((row, i) => ({
      date:
        dateData[i + (dateData.length - indicators.macd.length)]?.date || null,

      MACD: row.MACD ?? 0,
      signal: row.signal ?? 0,
      histogram: row.histogram ?? 0,
    }));
  // Minute data for chart
  const histoMin = intraday?.historicalData;
  console.log("histoMin", histoMin);
  const macdChartDataMin =
    Array.isArray(intradayIndicators?.macd) &&
    intradayIndicators?.macd.map((row, i) => ({
      date:
        histoMin?.[i + (histoMin?.length - intradayIndicators?.macd?.length)]
          ?.date || i + 1,
      MACD: row.MACD ?? 0,
      signal: row.signal ?? 0,
      histogram: row.histogram ?? 0,
    }));

  console.log("Indicators", indicators);
  console.log("Historical", historical);
  console.log("MACD Chart Data:", macdChartData);
  console.log("Macr chart dat", macdChartDataMin);

  let rsiStatus = "N/A";
  let latestRSI = null;

  if (indicators.rsi && indicators.rsi.length > 0) {
    latestRSI = indicators.rsi.slice(-1)[0];
    if (latestRSI >= 70) rsiStatus = "Overbought";
    else if (latestRSI <= 30) rsiStatus = "Oversold";
    else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
    else rsiStatus = "Neutral-Bearish";
  }

  // ---- MACD ----
  let macdStatus = "N/A";
  let latestMACD = null;

  if (indicators.macd && indicators.macd.length > 0) {
    latestMACD = indicators.macd.slice(-1)[0];
    if (latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0) {
      macdStatus = "Bullish";
    } else if (
      latestMACD.MACD < latestMACD.signal &&
      latestMACD.histogram < 0
    ) {
      macdStatus = "Bearish";
    } else {
      macdStatus = "Neutral";
    }
  }

  let combined = "Neutral / Sideways";
  let combinedColor = "#e6eef3";
  if (rsiStatus.includes("Bullish") && macdStatus === "Bullish") {
    combined = "📈 Bullish momentum confirmed";
    combinedColor = "#2fd18a";
  } else if (rsiStatus.includes("Bearish") && macdStatus === "Bearish") {
    combined = "📉 Bearish momentum confirmed";
    combinedColor = "#f87171";
  }
  // const getInterpretation = (indicators) => {
  //   if (
  //     !indicators.macd ||
  //     indicators.macd.length === 0 ||
  //     !indicators.rsi ||
  //     indicators.rsi.length === 0
  //   ) {
  //     return { result: "⚠️ Insufficient data", color: "#e6eef3" };
  //   }

  //   const latestMACD = indicators.macd.slice(-1)[0];
  //   const latestRSI = indicators.rsi.slice(-1)[0];

  //   if (
  //     latestRSI > 50 &&
  //     latestMACD.MACD > latestMACD.signal &&
  //     latestMACD.histogram > 0
  //   ) {
  //     return {
  //       result: "📈 Bullish momentum confirmed (RSI & MACD aligned)",
  //       color: "#2fd18a", // green
  //     };
  //   } else if (
  //     latestRSI < 50 &&
  //     latestMACD.MACD < latestMACD.signal &&
  //     latestMACD.histogram < 0
  //   ) {
  //     return {
  //       result: "📉 Bearish momentum confirmed (RSI & MACD aligned)",
  //       color: "#f87171", // red
  //     };
  //   } else if (
  //     (latestRSI > 50 &&
  //       latestMACD.MACD < latestMACD.signal &&
  //       latestMACD.histogram < 0) ||
  //     (latestRSI < 50 &&
  //       latestMACD.MACD > latestMACD.signal &&
  //       latestMACD.histogram > 0)
  //   ) {
  //     return {
  //       result: "⚠️ Divergence detected (RSI and MACD conflict)",
  //       color: "#fbbf24", // amber/yellow
  //     };
  //   } else {
  //     return {
  //       result: "⚖️ Neutral / Sideways market",
  //       color: "#e6eef3", // neutral grey
  //     };
  //   }
  // };

  const data = pcrStore[companyCode];
  console.log("Data", data);

  useEffect(() => {
    if (id) {
      fetchAllStockData();
      setLastUpdated(formatTimestamp());
      // loadData(companyCode);
      // fetchStockData(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const loadSingleStock = async () => {
    const res = await getSecurityIds(companyCode);

    const securityId = res?.[0]?.security_id ?? null;
    setSecurityId(securityId);
    console.log("Security ID:", securityId);
  };
  console.log("Security Id", securityId);

  useEffect(() => {
    if (companyCode) {
      fetchBySymbol(companyCode);
    }
    loadSingleStock();
  }, [companyCode]);
  useEffect(() => {
    console.log("🟡 securityId changed:", securityId);

    if (!securityId) {
      console.warn("⛔ fetchIndicators skipped: securityId missing");
      return;
    }

    fetchIndicators(securityId);
    getPrevClose(securityId);
    getMarketQuote(securityId);
  }, [securityId]);
  // ✅ dependency

  console.log("Indicators data", indicatorData);
  console.log("Previous Close", previousClose);
  console.log("Market Quote", quoteData);
  const quote = quoteData?.[securityId];
  console.log("Dhan quote data", quote);

  const latestRSIValue =
    indicatorData?.indicators?.rsi?.length > 0
      ? indicatorData.indicators.rsi.at(-1).value
      : null;
  const latestMACDValue =
    indicatorData?.indicators?.macd?.length > 0
      ? indicatorData.indicators.macd.at(-1).macd
      : null;

  console.log("Latest Rsi from dhan", latestRSIValue);
  console.log("Latest MAcd from dhan", latestMACDValue);

  //  useEffect(() => {
  //   if (companyCode) {
  //     loadData(companyCode);
  //     console.log("🚀 Loading PCR for:", companyCode);
  //   }
  // }, [companyCode]);

  const getInterpretation = (indicators) => {
    // --- SAFETY CHECK ---
    if (
      !indicators ||
      !Array.isArray(indicators.macd) ||
      !Array.isArray(indicators.rsi) ||
      indicators.macd.length === 0 ||
      indicators.rsi.length === 0
    ) {
      return {
        result: " Insufficient data",
        color: "#fbbf24",
        prediction: "Neutral",
      }; // gray
    }

    // --- GET LATEST VALUES ---
    const latestMACD = indicators.macd.slice(-1)[0];
    const latestRSI = indicators.rsi.slice(-1)[0];

    // --- DETERMINE RSI STATUS ---
    let rsiStatus = "Neutral";
    if (latestRSI >= 70) rsiStatus = "Overbought";
    else if (latestRSI <= 30) rsiStatus = "Oversold";
    else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
    else rsiStatus = "Neutral-Bearish";

    // --- DETERMINE MACD STATUS ---
    let macdStatus = "Neutral";
    if (latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0) {
      macdStatus = "Bullish";
    } else if (
      latestMACD.MACD < latestMACD.signal &&
      latestMACD.histogram < 0
    ) {
      macdStatus = "Bearish";
    }
    //let bgColor = "#e6eef3"; // default light gray

    // if (result?.includes("Bullish")) {
    //   resultColor = "#2fd18a";
    //   bgColor = "#D4F7E6";
    // } else if (result?.includes("Bearish")) {
    //   resultColor = "#f87171";
    //   bgColor = "#FFE1E1";
    // } else if (result?.includes("Divergence")) {
    //   resultColor = "#fbbf24";
    //   bgColor = "#FFF5CC";
    // }

    // --- COMBINED INTERPRETATION ---
    // RSI + MACD agree strongly → high-confidence momentum
    if (
      (rsiStatus.includes("Bullish") || latestRSI > 55) &&
      macdStatus === "Bullish"
    ) {
      return {
        result: " Strong Bullish Momentum (RSI & MACD aligned)",
        color: "#249966",
        bgColor: "#D4F7E6",
        prediction: "Buy", // green
      };
    }

    if (
      (rsiStatus.includes("Bearish") || latestRSI < 45) &&
      macdStatus === "Bearish"
    ) {
      return {
        result: "Strong Bearish Momentum (RSI & MACD aligned)",
        color: "#f87171",
        bgColor: "#FFE1E1",
        prediction: "Sell", // red
      };
    }

    // --- DIVERGENCE CASES ---
    // RSI uptrend but MACD downtrend or vice versa
    if (
      (latestRSI > 50 &&
        latestMACD.MACD < latestMACD.signal &&
        latestMACD.histogram < 0) ||
      (latestRSI < 50 &&
        latestMACD.MACD > latestMACD.signal &&
        latestMACD.histogram > 0)
    ) {
      return {
        result:
          " Divergence detected (RSI and MACD conflict) - Possible reversal ahead",
        color: "#fbbf24",
        bgColor: "#FFF5CC",
        prediction: "Neutral", // yellow
      };
    }

    // --- EXTREME CONDITIONS ---
    if (rsiStatus === "Overbought" && macdStatus === "Bullish") {
      return {
        result: " Overbought! Bullish but nearing exhaustion",
        color: "#f59e0b",
        bgColor: "#FFF5CC",
        prediction: "Sell", // amber-orange
      };
    }

    if (rsiStatus === "Oversold" && macdStatus === "Bearish") {
      return {
        result: " Oversold! Bearish but near potential rebound zone",
        color: "#60a5fa",
        bgColor: "#FFF5CC",
        prediction: "Buy",
        // blu
      };
    }

    // --- NEUTRAL / SIDEWAYS ---
    return {
      result: " Neutral / Sideways Market (No strong signal)",
      color: "#9ca3af",
      bgColor: "#FFF5CC",
      prediction: "Neutral", // grayish neutral
    };
  };
  // const getInterpretation = (indicators) => {

  //   const lighten = (hex, amount = 0.1) => {
  //     const num = parseInt(hex.replace("#", ""), 16);

  //     let r = (num >> 16) & 255;
  //     let g = (num >> 8) & 255;
  //     let b = num & 255;

  //     // Only lighten by 10 percent
  //     r = Math.min(255, Math.floor(r + (255 - r) * amount));
  //     g = Math.min(255, Math.floor(g + (255 - g) * amount));
  //     b = Math.min(255, Math.floor(b + (255 - b) * amount));

  //     return `rgb(${r}, ${g}, ${b})`;
  //   };

  //   // --- SAFETY CHECK ---
  //   if (
  //     !indicators ||
  //     !Array.isArray(indicators.macd) ||
  //     !Array.isArray(indicators.rsi) ||
  //     indicators.macd.length === 0 ||
  //     indicators.rsi.length === 0
  //   ) {
  //     const color = "#e6eef3";
  //     return {
  //       result: "⚠️ Insufficient data",
  //       color,
  //       bgColor: lighten(color),
  //       prediction: "Neutral",
  //     };
  //   }

  //   // --- GET LAST VALUES ---
  //   const latestMACD = indicators.macd.slice(-1)[0];
  //   const latestRSI = indicators.rsi.slice(-1)[0];

  //   // --- RSI STATUS ---
  //   let rsiStatus = "Neutral";
  //   if (latestRSI >= 70) rsiStatus = "Overbought";
  //   else if (latestRSI <= 30) rsiStatus = "Oversold";
  //   else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
  //   else rsiStatus = "Neutral-Bearish";

  //   // --- MACD STATUS ---
  //   let macdStatus = "Neutral";
  //   if (latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0) {
  //     macdStatus = "Bullish";
  //   } else if (
  //     latestMACD.MACD < latestMACD.signal &&
  //     latestMACD.histogram < 0
  //   ) {
  //     macdStatus = "Bearish";
  //   }

  //   // ------------------ COMBINED INTERPRETATION ------------------

  //   // Strong Bullish
  //   if (
  //     (rsiStatus.includes("Bullish") || latestRSI > 55) &&
  //     macdStatus === "Bullish"
  //   ) {
  //     const color = "#2fd18a";
  //     return {
  //       result: "📈 Strong Bullish Momentum (RSI & MACD aligned)",
  //       color,
  //       bgColor: lighten(color),
  //       prediction: "Buy",
  //     };
  //   }

  //   // Strong Bearish
  //   if (
  //     (rsiStatus.includes("Bearish") || latestRSI < 45) &&
  //     macdStatus === "Bearish"
  //   ) {
  //     const color = "#f87171";
  //     return {
  //       result: "📉 Strong Bearish Momentum (RSI & MACD aligned)",
  //       color,
  //       bgColor: lighten(color),
  //       prediction: "Sell",
  //     };
  //   }

  //   // Divergence
  //   if (
  //     (latestRSI > 50 &&
  //       latestMACD.MACD < latestMACD.signal &&
  //       latestMACD.histogram < 0) ||
  //     (latestRSI < 50 &&
  //       latestMACD.MACD > latestMACD.signal &&
  //       latestMACD.histogram > 0)
  //   ) {
  //     const color = "#fbbf24";
  //     return {
  //       result:
  //         "⚠️ Divergence detected (RSI and MACD conflict) - Possible reversal ahead",
  //       color,
  //       bgColor: lighten(color),
  //       prediction: "Neutral",
  //     };
  //   }

  //   // Overbought Bullish
  //   if (rsiStatus === "Overbought" && macdStatus === "Bullish") {
  //     const color = "#f59e0b";
  //     return {
  //       result: "🚨 Overbought! Bullish but nearing exhaustion",
  //       color,
  //       bgColor: lighten(color),
  //       prediction: "Sell",
  //     };
  //   }

  //   // Oversold Bearish
  //   if (rsiStatus === "Oversold" && macdStatus === "Bearish") {
  //     const color = "#60a5fa";
  //     return {
  //       result: "🩸 Oversold! Bearish but near potential rebound zone",
  //       color,
  //       bgColor: lighten(color),
  //       prediction: "Buy",
  //     };
  //   }

  //   // Neutral Case
  //   const color = "#9ca3af";
  //   return {
  //     result: "⚖️ Neutral / Sideways Market (No strong signal)",
  //     color,
  //     bgColor: lighten(color),
  //     prediction: "Neutral",
  //   };
  // };

  const { result, color, prediction, bgColor } = getInterpretation(indicators);
  const {
    result: result1,
    color: color1,
    prediction: prediction1,
    bgColor: bgColor1,
  } = getInterpretation(intradayIndicators);
  console.log("Prediction", prediction);
  console.log("Result1", result1);
  console.log("Color1", color1);
  console.log("Result", result);

  let resultColor = "#e6eef3"; // default neutral

  if (result?.includes("Bullish")) {
    resultColor = "#2fd18a"; // green
  } else if (result?.includes("Bearish")) {
    resultColor = "#f87171"; // red
  } else if (result?.includes("Divergence")) {
    resultColor = "#fbbf24"; // amber/yellow
  } else {
    resultColor = "#e6eef3"; // neutral grey
  }

  // useEffect(() => {
  //   if (companyCode) {
  //     loadData(companyCode);
  //     console.log("🚀 Loading PCR for:", companyCode);
  //   }
  // }, [companyCode]);

  console.log("Pcr from context", pcr);
  // const formatVolume = (volume) => {
  //   return typeof volume === "string"
  //     ? Number(volume).toLocaleString()
  //     : volume.toLocaleString();
  // };
  const formatVolume = (volume) => {
    if (volume == null) return "-"; // catches null & undefined

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };
  console.log("formatVolume", formatVolume);
  const selectedData =
    timeFrame === "min"
      ? Array.isArray(macdChartDataMin)
        ? macdChartDataMin
        : []
      : Array.isArray(macdChartData)
        ? macdChartData
        : [];
  const options = data?.filtered?.data;
  const ceOI =
    options &&
    options
      .filter((item) => item?.CE)
      .reduce((sum, item) => sum + (item?.CE?.openInterest || 0), 0);
  const peOI =
    options &&
    options
      .filter((item) => item.PE)
      .reduce((sum, item) => sum + (item.PE.openInterest || 0), 0);
  // const pcr = (peOI / ceOI).toFixed(2);
  // console.log("Pcr", pcr);
  return (
    <>
      <div>
        {/* <div style={{ textAlign: "right", margin: "10px" }}>
          <button
            className="rec-btn"
            onClick={handleRefresh}
            disabled={loading}
          >
            {loading ? "Refreshing..." : "Refresh Data"}
          </button>
        </div> */}
        <div className="last-updated-head">
          {lastUpdated && <span>As on {lastUpdated}</span>}
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>

        {loading ? (
          <p
            style={{
              fontSize: "1rem",
              fontWeight: "700",
              color: "black",
              display: "flex",
              gap: "1rem",
            }}
          >
            Fetching Live data..{" "}
            <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
              <FaSpinner />
            </span>
          </p>
        ) : error ? (
          <p
            style={{
              fontSize: "1rem",
              fontWeight: "700",
              color: "black",
              display: "flex",
              gap: "1rem",
            }}
          >
            Failed to load data refresh again..{" "}
          </p>
        ) : (
          <>
            <div className="stock-detail-card">
              {/* <div className="stock-extra-table-container">
                <div className="stock-extra-cards">
                  {stock ? (
                    <>
                      <div className="stock-extra-card company-card">
                        <div className="company-left">
                          <div className="company-text">
                            <p className="card-label">Company</p>

                            <p className="card-value">{companyName}</p>
                          </div>
                        </div>
                        <div className="company-left">
                          <div className="company-text">
                            <p className="card-label">NSE CODE</p>

                            <p className="card-value">{companyCode}</p>
                          </div>
                        </div>

                        <div className="company-right">
                          <p
                            className="result-value"
                            style={{
                              color: timeFrame === "min" ? color1 : color,
                            }}
                          >
                            {timeFrame === "min" ? result1 : result}
                          </p>
                        </div>
                        <div className="company-right">
                          <button
                            className="view-more-btn-stock"
                            style={{
                              backgroundColor:
                                timeFrame === "min" ? color1 : color,
                            }}
                          >
                            {timeFrame === "min" ? prediction1 : prediction}
                          </button>
                        </div>
                      </div>

                      <div className="extra-cards-grid grid-desktop">
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">LTP</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.ltp}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">RSI</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {latestRSI?.toFixed(2) > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color: latestRSI > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestRSI?.toFixed(2)}
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Open</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.open}</p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Low</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.low}</p>
                          </div>
                        </div>
                        <div
                          className={`stock-extra-card ${
                            stock?.percent_change >= 0 ? "positive" : "negative"
                          }`}
                        >
                          <div className="card-left">
                            <p className="card-label">% Change</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {stock.day_change_percent > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  stock?.day_change_percent > 0
                                    ? "#2fd18a"
                                    : "#f87171",
                              }}
                            >
                              {stock?.day_change_percent?.toFixed(2)}%
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">MACD</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {latestMACD?.MACD > 0 > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  latestMACD?.MACD > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestMACD?.MACD?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Close</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.close}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">High</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.high}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Upside</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "1rem" }}
                          >
                            {projectChange > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  projectChange > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {projectChange}%
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Target Price</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{target_price}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Volume</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              {formatVolume(stock?.volume)}
                            </p>
                          </div>
                        </div>

                        {peRatio && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              <p className="card-label">PE Ratio</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{peRatio}</p>
                            </div>
                          </div>
                        )}

                        {faceValue && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              <p className="card-label">Face Value</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{faceValue}</p>
                            </div>
                          </div>
                        )}

                        {pcr && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              <p className="card-label">PCR</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{pcr}</p>
                            </div>
                          </div>
                        )}
                        <div
                          className="stock-extra-card"
                          style={{
                            backgroundColor: "#2fd18a",
                            color: "white",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`/pcr/${companyCode}`);
                          }}
                        >
                          <div className="card-left">
                            <p className="card-label">Option Chain</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              <FaChevronRight />
                            </p>
                          </div>
                        </div>

                        <div
                          className="stock-extra-card"
                          style={{
                            backgroundColor: "#2fd18a",
                            color: "white",
                            cursor: "pointer",
                          }}
                        >
                          <div className="card-left">
                            <p className="card-label">Add to Watchlist</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              <MdOutlineNoteAdd />
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="extra-cards-grid grid-mobile">
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">LTP</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.ltp}</p>
                          </div>
                        </div>
                        <div
                          className={`stock-extra-card ${
                            stock?.percent_change >= 0 ? "positive" : "negative"
                          }`}
                        >
                          <div className="card-left">
                            <p className="card-label">% Change</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {stock.day_change_percent > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  stock?.day_change_percent > 0
                                    ? "#2fd18a"
                                    : "#f87171",
                              }}
                            >
                              {stock?.day_change_percent?.toFixed(2)}%
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Open</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.open}</p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Close</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.close}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Low</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.low}</p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">High</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{stock?.high}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">RSI</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {latestRSI?.toFixed(2) > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color: latestRSI > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestRSI?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">MACD</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {latestMACD?.MACD > 0 > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  latestMACD?.MACD > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {latestMACD?.MACD?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">~Upside</p>
                          </div>
                          <div
                            className="card-right"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {projectChange > 0 ? (
                              <IoMdTrendingUp
                                className="card-icon"
                                color="#2fd18a"
                              />
                            ) : (
                              <IoMdTrendingDown
                                className="card-icon"
                                color="#f87171"
                              />
                            )}
                            <p
                              className="card-value"
                              style={{
                                color:
                                  projectChange > 0 ? "#2fd18a" : "#f87171",
                              }}
                            >
                              {projectChange}%
                            </p>
                          </div>
                        </div>
                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Target Price</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">₹{target_price}</p>
                          </div>
                        </div>

                        <div className="stock-extra-card">
                          <div className="card-left">
                            <p className="card-label">Volume</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              {formatVolume(stock?.volume)}
                            </p>
                          </div>
                        </div>

                        {peRatio && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              <p className="card-label">PE Ratio</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{peRatio}</p>
                            </div>
                          </div>
                        )}

                        {faceValue && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              <p className="card-label">Face Value</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{faceValue}</p>
                            </div>
                          </div>
                        )}

                        {pcr && (
                          <div className="stock-extra-card">
                            <div className="card-left">
                              <p className="card-label">PCR</p>
                            </div>
                            <div className="card-right">
                              <p className="card-value">{pcr}</p>
                            </div>
                          </div>
                        )}
                        <div
                          className="stock-extra-card"
                          style={{
                            backgroundColor: "#2fd18a",
                            color: "white",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`/pcr/${companyCode}`);
                          }}
                        >
                          <div className="card-left">
                            <p className="card-label">Option Chain</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              <FaChevronRight />
                            </p>
                          </div>
                        </div>
                        <div
                          className="stock-extra-card"
                          style={{
                            backgroundColor: "#2fd18a",
                            color: "white",
                            cursor: "pointer",
                          }}
                        >
                       
                          <div className="card-left">
                            <p className="card-label">Add to Watchlist</p>
                          </div>
                          <div className="card-right">
                            <p className="card-value">
                              <MdOutlineNoteAdd />
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <p
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "white",
                        display: "flex",
                        gap: "1rem",
                      }}
                    >
                      Fetching Live data..{" "}
                      <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
                        <FaSpinner />
                      </span>
                    </p>
                  )}
                </div>
              </div> */}
              <div className="analysis-container">
                <div className="analysis-header">
                  <div className="analysis-head-name">
                    <h2 className="stock-title">{companyName}</h2>
                    <span className="stock-tag">{companyCode}</span>
                  </div>

                  <div className="action-buttons">
                    {/* <button className="btn-buy">Buy</button>
                    <button className="btn-sell">Sell</button>
                    <button className="btn-hold">Hold</button> */}
                    <button
                      className="btn-star"
                      onClick={() => navigate(`/stocktest/${companyCode}`)}
                    >
                      ★
                    </button>
                  </div>
                </div>
                <div
                  className="insight-box"
                  style={{
                    borderLeft:
                      timeFrame === "min"
                        ? `4px solid ${color1}`
                        : `4px solid ${color}`,
                  }}
                >
                  <p className="insight-head">Phro Trader Insights</p>
                  <div className="sub-insight">
                    <div
                      className="insight-text"
                      style={{
                        color: timeFrame === "min" ? color1 : color,
                      }}
                    >
                      {timeFrame === "min" ? result1 : result}
                    </div>
                    <button
                      className="insight-tag"
                      style={{
                        backgroundColor: timeFrame === "min" ? color1 : color,
                        color: "white",
                      }}
                    >
                      {timeFrame === "min" ? prediction1 : prediction}
                    </button>
                  </div>
                </div>

                <div className="price-summary">
                  <div className="price-chip">
                    <p className="label">LTP</p>
                    <h3 className="value">₹{stock?.ltp}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">% Change</p>
                    <h3
                      className="value positive"
                      style={{
                        color:
                          stock?.day_change_percent > 0 ? "#249966" : "#f87171",
                      }}
                    >
                      {stock?.day_change_percent >= 0
                        ? `+${stock?.day_change_percent?.toFixed(2)}%`
                        : `${stock?.day_change_percent?.toFixed(2)}%`}
                    </h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">Open</p>
                    <h3 className="value">₹{stock?.open}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">Close</p>
                    <h3 className="value">₹{stock?.close}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">Low</p>
                    <h3 className="value">₹{stock?.low}</h3>
                  </div>
                  <div className="price-chip">
                    <p className="label">High</p>
                    <h3 className="value">₹{stock?.high}</h3>
                  </div>
                </div>

                <div className="factor-wrapper">
                  <div className="factor-box">
                    <h4>Technical Factors</h4>
                    <div className="inner-factor-box">
                      <div className="factor-row">
                        <p>RSI</p>
                        <span
                          style={{
                            color: latestRSI > 0 ? "#249966" : "#f87171",
                          }}
                        >
                          {" "}
                          {latestRSI?.toFixed(2)}
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>MACD</p>
                        <span
                          // className="positive"
                          style={{
                            color: latestRSI > 0 ? "#249966" : "#f87171",
                          }}
                        >
                          {latestMACD?.MACD?.toFixed(2)}
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>Volume</p>

                        <span> {formatVolume(stock?.volume)}</span>
                      </div>
                      <div className="factor-row">
                        <p>PCR</p>
                        <span>{pcr?.value}</span>
                      </div>
                    </div>
                  </div>

                  <div className="factor-box">
                    <h4>Fundamental Factors</h4>
                    <div className="inner-factor-box">
                      <div className="factor-row">
                        <p>% Upside</p>
                        <span
                          className="positive"
                          style={{
                            color: projectChange > 0 ? "#249966" : "#f87171",
                          }}
                        >
                          {" "}
                          {projectChange}%
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>Target Price</p>
                        <span>₹{target_price}</span>
                      </div>
                      <div className="factor-row">
                        <p>P/E Ratio</p>
                        <span>{peRatio}</span>
                      </div>
                      <div className="factor-row">
                        <p>Face Value</p>
                        <span>₹{faceValue}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 
                <div
                  className="insight-box"
                  style={{
                    borderLeft:
                      timeFrame === "min"
                        ? `4px solid ${color1}`
                        : `4px solid ${color}`,
                  }}
                >
                  <p className="insight-head">Phro Trader Insights</p>
                  <div className="sub-insight">
                    <div
                      className="insight-text"
                      style={{
                        color: timeFrame === "min" ? color1 : color,
                      }}
                    >
                      {timeFrame === "min" ? result1 : result}
                    </div>
                    <button
                      className="insight-tag"
                      style={{
                        backgroundColor: timeFrame === "min" ? color1 : color,
                        color: "white",
                      }}
                    >
                      {timeFrame === "min" ? prediction1 : prediction}
                    </button>
                  </div>
                </div> */}
                <div
                  className="option-chain-div
                "
                >
                  <p>Option Chain</p>
                  <button
                    className="rec-btn"
                    // onClick={() => {
                    //   navigate(`/pcr/${companyCode}`);
                    // }}
                    onClick={() => {
                      navigate(`/optionpage/${companyCode}`);
                    }}
                  >
                    View Option Chain
                  </button>
                </div>
              </div>
            </div>
            {/* <div className="analysis-container">
              <div className="analysis-header">
                <div className="analysis-head-name">
                  <h2 className="stock-title">{companyName}</h2>
                  <span className="stock-tag">{companyCode}</span>
                </div>

                <div className="action-buttons">
                  <button className="btn-buy">Buy</button>
                  <button className="btn-sell">Sell</button>
                  <button className="btn-hold">Hold</button>
                  <button className="btn-star">★</button>
                </div>
              </div>

              <div className="price-summary">
                <div className="price-chip">
                  <p className="label">LTP</p>
                  <h3 className="value">₹{stock?.ltp}</h3>
                </div>
                <div className="price-chip">
                  <p className="label">% Change</p>
                  <h3
                    className="value positive"
                    style={{
                      color:
                        stock?.day_change_percent > 0 ? "#2fd18a" : "#f87171",
                    }}
                  >
                    {stock?.day_change_percent >= 0
                      ? `+${stock?.day_change_percent?.toFixed(2)}%`
                      : `${stock?.day_change_percent?.toFixed(2)}%`}
                  </h3>
                </div>
                <div className="price-chip">
                  <p className="label">Open</p>
                  <h3 className="value">₹{stock?.open}</h3>
                </div>
                <div className="price-chip">
                  <p className="label">Close</p>
                  <h3 className="value">₹{stock?.close}</h3>
                </div>
                <div className="price-chip">
                  <p className="label">Low</p>
                  <h3 className="value">₹{stock?.low}</h3>
                </div>
                <div className="price-chip">
                  <p className="label">High</p>
                  <h3 className="value">₹{stock?.high}</h3>
                </div>
              </div>

              <div className="factor-wrapper">
                <div className="factor-box">
                  <h4>Technical Factors</h4>
                  <div className="inner-factor-box">
                    <div className="factor-row">
                      <p>RSI</p>
                      <span
                        style={{
                          color: latestRSI > 0 ? "#2fd18a" : "#f87171",
                        }}
                      >
                        {" "}
                        {latestRSI?.toFixed(2)}
                      </span>
                    </div>
                    <div className="factor-row">
                      <p>MACD</p>
                      <span className="positive">
                        {latestMACD?.MACD?.toFixed(2)}
                      </span>
                    </div>
                    <div className="factor-row">
                      <p>Volume</p>

                      <span> {formatVolume(stock?.volume)}</span>
                    </div>
                    <div className="factor-row">
                      <p>PCR</p>
                      <span>{pcr}</span>
                    </div>
                  </div>
                </div>

                <div className="factor-box">
                  <h4>Fundamental Factors</h4>
                  <div className="inner-factor-box">
                    <div className="factor-row">
                      <p>% Upside</p>
                      <span
                        className="positive"
                        style={{
                          color: projectChange > 0 ? "#2fd18a" : "#f87171",
                        }}
                      >
                        {" "}
                        {projectChange}%
                      </span>
                    </div>
                    <div className="factor-row">
                      <p>Target Price</p>
                      <span>₹{target_price}</span>
                    </div>
                    <div className="factor-row">
                      <p>P/E Ratio</p>
                      <span>{peRatio}</span>
                    </div>
                    <div className="factor-row">
                      <p>Face Value</p>
                      <span>₹{faceValue}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="insight-box">
                <p className="insight-head">Pro Trader Insights</p>
                <div className="sub-insight">
                  <div
                    className="insight-text"
                    style={{
                      color: timeFrame === "min" ? color1 : color,
                    }}
                  >
                    {timeFrame === "min" ? result1 : result}
                  </div>
                  <button className="insight-tag bullish">
                    {timeFrame === "min" ? prediction1 : prediction}
                  </button>
                </div>
              </div>
            </div> */}

            {macdChartData && macdChartData.length > 0 && (
              <div className="macd-chart-graph">
                <div className="chart-top-heading">
                  <h3
                  // style={{
                  //   color: "#fff",
                  //   fontWeight: "bold",
                  //   fontSize: "1.5rem",
                  //   marginLeft: "1.5rem",
                  // }}
                  >
                    📊 MACD Line, Signal & Histogram
                  </h3>
                  <div className="chart-select">
                    <label
                    // style={{
                    //   fontSize: "1rem",
                    //   fontWeight: "700",
                    //   color: "white",
                    //   marginRight: "10px",
                    // }}
                    >
                      Interval
                    </label>
                    <select
                      name=""
                      id=""
                      value={timeFrame}
                      onChange={(e) => setTimeFrame(e.target.value)}
                      style={{
                        background: "inherit",
                        // color: "white",
                        fontWeight: "600",
                        color: "black",
                        // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                        boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
                        padding: "5px 7px",
                        borderRadius: "10px",
                      }}
                    >
                      <option value="min">Minute</option>
                      <option value="day">Day</option>
                    </select>
                  </div>
                </div>
                <ResponsiveContainer width="100%" height={300}>
                  <ComposedChart data={selectedData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#374151" />

                    {/* X-Axis */}
                    {/* <XAxis
                      dataKey="date"
                      tickFormatter={(date) => {
                        const d = parseISO(date);
                        // Only show the month label on the 1st of each month
                        if (format(d, "dd") === "01") {
                          return format(d, "MMM"); // "May", "Jun", "Jul"
                        }
                        return ""; // hide all other ticks
                      }}
                      tick={{ fill: "#fff", fontWeight: "bold" }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    /> */}
                    {/* <XAxis
                      dataKey="date"
                      tickFormatter={(date, index) => {
                        if (!date) return "";

                        try {
                          const hasTime = date.includes(":");
                          const d = new Date(date.replace(" ", "T"));
                          // ensures consistent parsing
                          console.log("D:", d);

                          if (hasTime) {
                            // ⏱ Case 1: Intraday data → show time every 30 minutes (roughly index % 15)
                            return index % 15 === 0
                              ? d.toLocaleTimeString("en-IN", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })
                              : "";
                          } else {
                            // 📅 Case 2: Daily data → show date every 10 days
                            return index % 10 === 0
                              ? d.toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "short",
                                })
                              : "";
                          }
                        } catch {
                          return "";
                        }
                      }}
                      tick={{ fill: "#fff", fontWeight: "bold" }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    /> */}
                    <XAxis
                      dataKey="date"
                      tickFormatter={(date, index) => {
                        if (!date || typeof date !== "string") return "";
                        try {
                          const hasTime = date.includes(":");
                          // const safeDate = date.replace(" ", "T");
                          const d = new Date(date.replace(" ", "T"));
                          // console.log("Safedate", safeDate);
                          // const d = new Date(safeDate);
                          // console.log("D", d);

                          // if (isNaN(d.getTime())) return ""; // invalid date guard

                          // Intraday → show every 30 mins
                          if (hasTime) {
                            const timeLabel =
                              index % 15 === 0
                                ? d.toLocaleTimeString("en-IN", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                : "";

                            // console.log(`Tick ${index}:`, {
                            //   date,
                            //   formatted: timeLabel,
                            // });
                            return timeLabel;
                          }

                          // Daily → show every 10th day
                          return index % 10 === 0
                            ? d.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                              })
                            : "";
                        } catch {
                          return "";
                        }
                      }}
                      tick={{
                        // fill: "#fff",
                        fontWeight: "bold",
                        fontSize: 10,
                      }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    />

                    {/* Y-Axis */}
                    <YAxis
                      tick={{
                        //  fill: "#fff",

                        fontWeight: "bold",
                        fontSize: 10,
                      }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    />

                    {/* Tooltip */}
                    {/* <Tooltip
                      contentStyle={{
                        backgroundColor: "#1f2937",
                        border: "none",
                      }}
                      labelStyle={{ color: "#fff", fontWeight: "bold" }}
                      itemStyle={{ color: "#fff" }}
                      labelFormatter={(date) => {
                        // full date inside tooltip → "May 19, 2025"
                        const d = parseISO(date);
                        return format(d, "MMM dd, yyyy");
                      }}
                    /> */}
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#1f2937",
                        border: "none",
                        color: "#fff",
                      }}
                      labelFormatter={(label) => {
                        try {
                          if (!label) return "";
                          const hasTime = label.includes(":");
                          const d = new Date(label.replace(" ", "T"));
                          if (isNaN(d.getTime())) return label;

                          if (hasTime) {
                            // ⏱ Intraday case → show date + time
                            return d.toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            });
                          } else {
                            // 📅 Daily case → show only date
                            return d.toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            });
                          }
                        } catch (err) {
                          return label;
                        }
                      }}
                      labelStyle={{ color: "#fff", fontWeight: "bold" }}
                      itemStyle={{ color: "#fff" }}
                    />

                    {/* <Legend
                      wrapperStyle={{ color: "#fff", fontWeight: "bold" }}
                    /> */}
                    <Legend
                      wrapperStyle={{ fontWeight: "bold" }}
                      payload={[
                        {
                          value: "Histogram (Bullish)", // custom label
                          type: "square",
                          color: "#2fd18a", // green for positive
                        },
                        {
                          value: "Histogram (Bearish)",
                          type: "square",
                          color: "#f87171", // red for negative
                        },
                        {
                          value: "MACD",
                          type: "line",
                          color: "#2563eb", // blue line
                        },
                        {
                          value: "Signal",
                          type: "line",
                          color: "#f59e0b", // orange line
                        },
                      ]}
                    />

                    {/* Histogram bars */}
                    <Bar
                      dataKey="histogram"
                      name="Histogram"
                      // name={null}
                      barSize={20}
                      shape={(props) => {
                        const { x, y, width, height, value } = props;
                        return (
                          <rect
                            x={x}
                            y={value >= 0 ? y : y - height}
                            width={width}
                            height={Math.abs(height)}
                            fill={value >= 0 ? "#2fd18a" : "#f87171"}
                          />
                        );
                      }}
                    />

                    {/* MACD Line */}
                    <Line
                      type="monotone"
                      dataKey="MACD"
                      stroke="#2563eb"
                      strokeWidth={2}
                      dot={false}
                      name="MACD"
                    />

                    {/* Signal Line */}
                    <Line
                      type="monotone"
                      dataKey="signal"
                      stroke="#f59e0b"
                      strokeWidth={2}
                      dot={false}
                      name="Signal"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            )}

            {/* <div className="peer-section">
              <h2 className="peer-title">Peer Companies for {companyName}</h2>

              <div className="peer-grid">
                {mergedPeers?.map((item) => (
                  <div
                    key={stock.tickerId}
                    className="peer-card"
                    onClick={() => navigate(`/stock/${item?.tickerId}`)}
                  >
                    <h3 className="peer-name">{item?.companyName}</h3>
                   

                    <p className="peer-price">₹{item?.price}</p>

                    <p
                      className="peer-change"
                      style={{
                        color: item.percentChange >= 0 ? "#2fd18a" : "#f87171",
                      }}
                    >
                      {item.percent_change >= 0
                        ? `+${item.percentChange}%`
                        : `${item.percentChange}%`}
                    </p>
                  </div>
                ))}
              </div>
            </div> */}

            <div className="peer-list card">
              <h1>Peer Company Stocks for {companyName}</h1>
              <div className="stock-table-container">
                <table
                  className="stock-table stacked-mobile"
                  style={{ background: "transparent" }}
                >
                  <thead style={{ background: "#047cc2", color: "white" }}>
                    <tr>
                      <th>Company</th>
                      <th>Price</th>
                      <th>% Change</th>
                      {/* <th>PE Ratio</th>   */}

                      <th>Recommendation</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mergedPeers?.map((stock) => (
                      <tr
                        key={stock.tickerId}
                        className="stock-row"
                        style={{ background: "transparent" }}
                      >
                        <td className="mobile-name" style={{ color: "black" }}>
                          {stock.companyName}
                        </td>
                        <td
                          className="mobile-pair"
                          data-label="Price"
                          style={{ color: "black" }}
                        >
                          ₹{stock.price}
                        </td>

                        <td
                          style={{
                            color:
                              stock.percent_change >= 0 ? "#2fd18a" : "#f87171",
                            fontWeight: "bold",
                          }}
                          className="mobile-pair"
                          data-label="% Change"
                        >
                          {stock.percentChange}%
                        </td>
                        {/* <td
                          className="mobile-pair"
                          data-label="PE Ratio"
                          style={{ color: "black" }}
                        >
                          {stock.peRatio}
                        </td> */}

                        <td className="mobile-button">
                          <button
                            className="rec-btn"
                            onClick={() => navigate(`/stock/${stock.tickerId}`)}
                          >
                            BUY or SELL
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default StockDetails;
